import React, { useCallback, useEffect, useRef, useState } from 'react'
import './TeacherStudentSidebar.scss';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import images from '../../assets/images';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { logout, setRefetchNotification, setSplashvisible } from '../../redux/slices/authSlice';
import { STUDENT_ROLE, TEACHER_ROLE, VIRTUAL } from '../../utils/constants';
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES, GET_NOTIFICATIONS } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { useLazyQuery } from '@apollo/client';
import ToasterWithMessage from '../toaster';
import { setCategoryListLoading, setChangeMenu } from '../../redux/slices/dashboardSlice';
// import { UPDATE_ACTIVE_STATUS } from '../../pages/CommonChats/api/ChatsQuery';
// import { MeetingCategoryType } from '../../pages/AdminPta/AdminPta';
// import { GET_ALL_MEETING_CATEGORIES } from '../../pages/AdminPta/api/PtaQuery';
import { GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setChatTabIndication, setTabIndication } from '../../redux/slices/indication';
import { isPlatform } from '@ionic/react';
import { Tooltip } from '@mui/material';

interface notificationType{
  Announcement:number;
  Calender:number;
  Workshop:number
};

interface menuItemType {
  id: string;
  label: string;
  link: string;
  notificationKey?: string;
}

export interface MeetingCategoryType {
  mcId: string,
  mcType: string,
  mcTypeCapitalized: string,
  mcDescription: string,
  mcOrder: number,
  mcUrl: string,
  mcCode: string,
  deletedAt: string | null,
  createdAt: string
}

const TeacherStudentSidebar = () => {

  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
  const [openConfirmationPopup,setOpenConfirmationPopup] = useState<boolean>(false);
  const location = useLocation();
  const {rightSideArrow, LogoutIcons, logoutGif, SettingsIcons, HelpIcon, redDotImage} = images;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const role = useAppSelector((state) => state.auth.role);
  const classRoomName = useAppSelector((state) => state.auth.selectedClassRoomName);
  const [notification,setNotification] = useState<notificationType>();
  // const {error} = ToasterWithMessage();
  // const [allCategory, setAllCategory] = useState<MeetingCategoryType[]>([]);
  // const [oneMenuItems, setOneMenuItems] = useState<menuItemType[]>([]);
  // const changeMenu = useAppSelector((state) => state.dashboard.changeMenu);
  // const [showPtaSideBar, setShowPtaSideBar] = useState<boolean>(false);
  const refetchNotification = useAppSelector((state) => state?.auth?.refetchNotification);
  // let selectedCategory: MeetingCategoryType = location?.state?.category; 
  // const [isIndication, setIndication] = useState<boolean>(false)
  const isIndication = useAppSelector((state) => state.indication.tabIndication)
  const isIndicationChat = useAppSelector((state) => state.indication.chatTabIndication)
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  // const participantCode = useAppSelector((state) => state.auth.participantCode);
  // const schoolType = useAppSelector((state) => state.auth.schoolType);
  const [isOverflow, setIsOverflow] = useState(false);
  const schoolNameRef = useRef<HTMLDivElement | null>(null);

  let menuItems: menuItemType[] = [
    {id: "classroom", label: 'Classroom', link: role === STUDENT_ROLE ? '/student-classroom' : '/teacher-classroom'},
    {id: "announcement", label: 'Announcement', link: role === TEACHER_ROLE ? '/teacher-announcement':'/student-announcement', notificationKey: 'Announcement'},
  ]

  const setTwoMenuItems = [
    {id: "settings", label: 'Settings', link: role === TEACHER_ROLE ? '/teacher-settings' : '/student-settings', icon: SettingsIcons},
    {id: "logout", label: 'Logout', link: '/teacher-logout', icon: LogoutIcons, onClick: () => { setOpenConfirmationPopup(true); }},
  ]

  const [getNotifications] = useLazyQuery(GET_NOTIFICATIONS, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setNotification(data?.notifyUser);
    }
  });

  useEffect(()=>{
    getNotifications();
  },[]);

  useEffect(()=>{
    if (refetchNotification) {
      getNotifications();
      dispatch(setRefetchNotification({ refetchNotification: false }));
    }
  },[refetchNotification]);

  // useEffect(() => {
  //   setShowPtaSideBar(false);
  //   if (location.pathname === '/teacher-pta' || location.pathname === '/pta-meetings' || showPtaSideBar) {
  //     if (allCategory.length === 0 || allCategory === undefined)
  //       getAllMeetingCategory();
  //   }
  //   else {
  //     setOneMenuItems(menuItems);
  //   }
  // },[location.pathname])

  // useEffect(() => {
  //   if (changeMenu) {
  //     handleClick({id: "classroom", label: 'Classroom', link: '/teacher-classroom'});
  //     dispatch(setChangeMenu({changeMenu: false}));
  //   }
  // },[changeMenu])

  // useEffect(() => {
  //   dispatch(setCategoryListLoading({ categoryListLoading: categoryLoading }))
  // },[categoryLoading])

  // click yes button in confirmation popup
  const onClickYesButtonClick = () => {
      // Directly proceed with logout and other actions if not a TEACHER or STUDENT
      navigate(`/${`?isKaton=virtualSchool`}`);
      dispatch(logout());
      dispatch(setSplashvisible());
      setOpenConfirmationPopup(false);
  };


  // click no button in confirmation popup
  const onClickNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  const [getClassRoomUpdates] = useLazyQuery<GetClassroomUpdatesResponse, GetClassroomUpdatesVariables>(GET_CLASSROOM_UPDATES, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const { quiz, assignments, mylibrary, ebooks } = data.getClassroomUpdates;
      const quizCount = quiz.totalCount;
      const hasQuiz = quizCount > 0;
      const assignmentCount = assignments.totalCount;
      const hasAssignment = assignmentCount > 0;
      const myLibrayCount = mylibrary.totalCount;
      const ebooksCount = ebooks.totalCount;
      const hasMylibrary = myLibrayCount > 0;
      const hasEbooks = ebooksCount > 0;

      // Set tab indication based on either quiz or assignment presence
      dispatch(setTabIndication(hasMylibrary || hasEbooks));
    },
    onError: (err) => {
      console.log(err.message);
    },
  });

  //indication for chat
  // const [getIndicationChat] = useLazyQuery<GetChatCountResponse, GetClassroomUpdatesVariables>(GET_CHAT_INDICATION, {
  //   fetchPolicy: "network-only",
  //   onCompleted: (data) => {
  //     const chatCount = data.getAllChatCount;
  //     const hasChat = chatCount > 0;
  //     dispatch(setChatTabIndication(hasChat));
  //   },
  //   onError: (err) => {
  //     console.log(err.message);
  //   },
  // });

  const handleClick = async (menu: menuItemType) => {
    // if (menu?.link === "/teacher-pta" || menu?.link === "/pta-meetings") {
    //   await getAllMeetingCategory().then((res) => {
    //     navigate(menu?.link, {
    //       state: {
    //         category: menu?.id === "ptameetings" ? res.data?.allMeetingCategories?.nodes?.[0] : allCategory.filter((val: MeetingCategoryType) => val?.mcCode === menu?.id)?.[0]
    //       }
    //     });
    //   })
    // }
    // else {
      navigate(menu?.link);
    // }
    // if (role !== PTA_ROLE && role !== PARTICIPANT) {
      await getNotifications();
    // }
    
    // if((role === TEACHER_ROLE || role === STUDENT_ROLE) && schoolType !== VIRTUAL){
    //   updateChatActiveStatus({
    //     variables:{
    //       chatActive:false
    //     }
    //   });
    // }
    // if ((role === TEACHER_ROLE && schoolType !== VIRTUAL) || role === PTA_ROLE) {
    //   localStorage.setItem('isVerify','false');
    // }
    if(role === STUDENT_ROLE){
      getClassRoomUpdates({
        variables :{
          cId : selectedClassRoomId ?? ''
        }
      })
    //   if(schoolType !== VIRTUAL){
    //   getIndicationChat({
    //     variables: {
    //       cId: selectedClassRoomId ?? "",
    //     },
    //   });
    // }
    }
  }

  // const handleClickSchoolProfile = () => {
  //   if (location.pathname === '/teacher-pta' || location.pathname === '/pta-meetings') {
  //     setShowPtaSideBar(true);
  //   }
  //   if (role !== PTA_ROLE) {
  //     getNotifications();
  //   }
  //   if (location.pathname !== "/school-profile") {
  //     navigate("/school-profile", {
  //       state: {
  //         backNavigation: location.pathname,
  //         category: selectedCategory
  //       }
  //     });
  //   }
  //   if(role === STUDENT_ROLE){
  //     getClassRoomUpdates({
  //       variables :{
  //         cId : selectedClassRoomId ?? ''
  //       }
  //     })
  //     if(schoolType !== VIRTUAL){
  //     getIndicationChat({
  //       variables: {
  //         cId: selectedClassRoomId ?? "",
  //       },
  //     });
  //   }
  //   }
  // }  

  useEffect(()=>{
    if(selectedClassRoomId){
      if(role === STUDENT_ROLE){
        getClassRoomUpdates({
          variables :{
            cId : selectedClassRoomId ?? ''
          }
        })
      // if(schoolType !== VIRTUAL){
      // getIndicationChat({
      //   variables: {
      //     cId: selectedClassRoomId ?? "",
      //   },
      // });
      // }
    }
  }
  },[getClassRoomUpdates, role, selectedClassRoomId])


      //To check the container is overflow
      const checkOverflow = () => {
        if (schoolNameRef.current) {
          setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
        }
      }
  
      //To check overflow in resize 
      useEffect(() => {
        window.addEventListener('resize', checkOverflow);
    
        return () => {
          window.removeEventListener('resize', checkOverflow);
        };
      }, []);
    
      useEffect(() => {
        checkOverflow();
      }, [profile])


     
  
    const textRef = useRef<HTMLDivElement>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  const checkEllipsis = useCallback(() => {
    if (textRef.current) {
      setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  useEffect(() => {
    checkEllipsis();
    window.addEventListener("resize", checkEllipsis);
    return () => window.removeEventListener("resize", checkEllipsis);
  }, [checkEllipsis, StudentName]);


  const nameRef = useRef<HTMLDivElement>(null);
  const [isTextTruncated, setIsTextTruncated] = useState(false);

  // Function to check if text is truncated (ellipsis applied)
  const checkIfTruncated = useCallback(() => {
    if (nameRef.current) {
      setIsTextTruncated(nameRef.current.scrollWidth > nameRef.current.clientWidth);
    }
  }, []);

  return (
    <div className='teacherStudentSidebarMain'>
      <div className='subContainer'>
        <div className={`profileContainer`}>
          <div className={`schoolProfileContainer`}>
            <div className='schoolProfileTopContainer'>
              {(profileImage) && (
                <img 
                  className='profileImage'
                  alt="ProfileImage"
                  src={profileImage}
                />
              )}
            </div>
            <div className='schoolProfileBottomContainer' style={{gap: role === STUDENT_ROLE ? '8px' : ''}}>
            <Tooltip
                  title={`${profile?.schoolAdmin?.nodes?.[0]?.saName ? profile?.schoolAdmin?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                  disableHoverListener={!isOverflow}
                  placement="top">
                <div className='schoolNameStyle'>
                {`${profile?.schoolAdmin?.nodes?.[0]?.saName ? profile?.schoolAdmin?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                </div>
            </Tooltip>
                {
                  role === STUDENT_ROLE
                  ? 
                    <div className='studentTabStyle' onClick={(e) => e.stopPropagation()}>
<Tooltip title={isEllipsisActive ? StudentName || "Student" : ""} >
      <div
        ref={textRef}
        style={{
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          width: "100%",
          display: "block", // Ensure it works inside flex containers
        }}
      >
        {StudentName || "Student"}
      </div>
    </Tooltip>                      <div>{(profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cName && profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cName !== "") && <span>{profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cName}</span>}</div>
                    </div>
                  : role === TEACHER_ROLE ?
                  <div className='teacherTabStyle' onClick={(e) => e.stopPropagation()}>
<Tooltip title={isTextTruncated ? (StudentName || "Teacher") : ""}>
      <div
        ref={nameRef}
        className="namefield"
        onMouseEnter={checkIfTruncated} // Check ellipsis on hover
      >
        {StudentName ? StudentName : "Teacher"}
      </div>
    </Tooltip>                    <div>
                      {(classRoomName && classRoomName !== "") && <span>{classRoomName}</span>}
                    </div>
                  </div>
                  : ""
                }
                
            </div>
          </div>
          <div className='navigationsTop'>
            {
              menuItems?.map((menuitem: menuItemType, index: number) => {
                const notificationKey = menuitem.notificationKey as keyof notificationType;
                const notificationCount = notification ? notification[notificationKey] : 0;
                const isSelected = location.pathname.includes(menuitem?.link);
                return (<>
                  <button style={{ display: (menuitem?.label === 'Workshop' && role === STUDENT_ROLE) ? 'none' : 'flex' }} key={`${index}-${menuitem?.label}`} className={`sidebarOption ${isSelected ? 'selectedMenu' : ''}`} onClick={() => handleClick(menuitem)}>
                    <span className='MenuLabel'>{menuitem?.label}</span>
                    {!isSelected && notificationCount > 0 && (
                      <span className='notificationBadge'>{notificationCount}</span>
                    )}
                    {isSelected && <img
                      src={rightSideArrow}
                      alt='arrowIcon'
                      className={`arrowIconStyle ${((location.pathname === menuitem?.link) || (location.pathname.includes(menuitem?.link))) ? 'visibleStyle' : 'nonVisibleStyle'}`}
                    />}
                    {(role === STUDENT_ROLE && menuitem?.label) === 'Classroom' && <img src={redDotImage} className='redDotStyle' alt='redDotImage' style={{visibility : isIndication || isIndicationChat ? 'visible':'hidden'}}/>}

                  </button>
                  </>
                )
              })
            }
          </div>
        </div>
          <div className={`navigationsBottom`}>
            <div className='setTwoMenuContainer'>
            {
              setTwoMenuItems?.map((item, index) => {
                const isSelected = (location.pathname === item?.link || location.pathname.includes(item?.link))
                return (
                  <div className='setTwoMenuItemStyle' key={`${index}-${item.label}`} onClick={item.onClick ? item.onClick : () => handleClick(item)}>
                      <img
                        src={item.icon}
                        alt='icon'
                        className='iconStyle'
                      />
                      <span className={`labelStyle ${isSelected && 'labelStyleActive'}`}>{item?.label}</span>
                  </div>
                )
              })
            }
            </div>
          </div>
      </div>
      <ConfirmationPopup
        open = {openConfirmationPopup}
        message = {`Are you sure you want to Log Out?`}
        gifData = {logoutGif}
        yesButtonFunctionality = {onClickYesButtonClick}
        noButtonFunctionality = {onClickNoButtonClick}
        messageWidth = {'221px'}
      />
    </div>
  )
}

export default TeacherStudentSidebar